export interface ICoreApp {
  workmanageID: number;
  appID: number;
  appName: string;
  checked: boolean;
  appChecked: boolean;
  winChecked: boolean;
  updFlg: boolean;
  delFlg: boolean;
}

export class CCoreApp implements ICoreApp {
  public workmanageID = 0;
  public appID = 0;
  public appName = '';
  public checked = false;
  public appChecked = false;
  public winChecked = false;
  public updFlg = false;
  public delFlg = false;
}
